module.exports = __webpack_public_path__ + "static/media/er.8d5171c7.svg";